export const PRODUCTS_TEST_IDS = {
  PAGE: 'products-page',
  SEARCH_SOURCE_ID: 'products-search-source-id',
  SEARCH_CODE: 'products-search-code',
  SEARCH_NAME: 'products-search-name',
  SEARCH_BARCODE: 'products-search-barcode',
  EXPORT_BTN: 'products-export-btn',
  FILTER_DROPDOWN: 'products-filter-dropdown',
  STATUS_FILTER: 'products-status-filter',
  TABLE: 'products-table',
  TABLE_ROW: (id: string) => `products-table-row-${id}`,
  COL_OPERATOR_ID: (id: string) => `products-col-operator-id-${id}`,
  COL_SOURCE_PRODUCT_ID: (id: string) => `products-col-source-product-id-${id}`,
  COL_PRODUCT_CODE: (id: string) => `products-col-product-code-${id}`,
  COL_NAME: (id: string) => `products-col-name-${id}`,
  COL_MARKETS_BTN: (id: string) => `products-col-markets-btn-${id}`,
  COL_BARCODES_BTN: (id: string) => `products-col-barcodes-btn-${id}`,
  COL_COST: (id: string) => `products-col-cost-${id}`,
  COL_PRICE: (id: string) => `products-col-price-${id}`,
  COL_STATUS: (id: string) => `products-col-status-${id}`,
  COL_UPDATED_ON: (id: string) => `products-col-updated-on-${id}`,
  COL_CREATED_ON: (id: string) => `products-col-created-on-${id}`,
  DIALOG_BARCODE_CARD: (id: string) => `products-dialog-barcode-card-${id}`,
  DIALOG_BARCODE_VALUE: (id: string) => `products-dialog-barcode-expanded-row-${id}`,
  DIALOG_MARKET_CARD: (id: string) => `products-dialog-market-card-${id}`,
  DIALOG_MARKET_NAME: (id: string) => `products-dialog-market-name-${id}`,
  DIALOG_MARKET_STATUS: (id: string) => `products-dialog-market-status-${id}`,
} as const;
